export default {
  props: {
    riskAnalysisId: {
      type   : String,
      default: ''
    }
  },
  computed: {
    id () {
      return this.riskAnalysisId || this.$route.params.id
    }
  }
}
